import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import RoutesList from '@/components/RoutesList.vue';
let StarshipsPage = class StarshipsPage extends Vue {
    get categories() {
        return [
            {
                category: '',
                routes: [
                    { to: '/starships/deployments', title: 'Deployments' },
                    { to: '/starships/ventures', title: 'Ventures' },
                    { to: '/starships/modifications', title: 'Modifications' },
                    { to: '/starships/equipment', title: 'Equipment' },
                    { to: '/starships/weapons', title: 'Weapons' }
                ]
            }
        ];
    }
};
StarshipsPage = __decorate([
    Component({
        components: {
            RoutesList
        }
    })
], StarshipsPage);
export default StarshipsPage;
